import React from 'react';
import { withTheme } from 'emotion-theming';

import { ChartDropdown as BaseChartDropdown } from '@ihme/common/web/components';
import dropdownStyles from '../../theme/dropdown-styles';
import dropdownLabelStyles from '../../theme/dropdown-label-styles';

export default withTheme(props => (
    <BaseChartDropdown
        {...props}
        styles={dropdownStyles(props.theme)}
        labelStyles={dropdownLabelStyles(props.theme)}
    />
));
